// Get JIRA issue key from environment variables (Vite prefix takes precedence)
const jiraIssueKey = import.meta.env.VITE_JIRA_ISSUE_KEY || import.meta.env.JIRA_ISSUE_KEY;

// Determine environment from Vite build mode (set via --mode flag)
// Modes: 'development' (local), 'staging' (dev cloud), 'production'
const mode = import.meta.env.MODE;
const isLocalDevelopment = mode === 'development';
const isDevDevelopment = mode === 'staging' || (jiraIssueKey && jiraIssueKey !== 'prod');

let serverUri, cdnUri;

if (isLocalDevelopment) {
  // Local development environment
  serverUri = 'http://localhost:8080';
  cdnUri = 'https://cdn.d.heatshrink.guru';
} else if (isDevDevelopment) {
  // Cloud development environment (ephemeral environment with JIRA issue key)
  serverUri = `https://${jiraIssueKey}-api.d.heatshrink.guru`;
  cdnUri = 'https://cdn.d.heatshrink.guru';
} else {
  // Production environment
  serverUri = 'https://api.heatshrink.guru';
  cdnUri = 'https://cdn.heatshrink.guru';
}

const config = {
  jiraIssueKey,
  serverUri,
  cdnUri
};

export default config;
